import React from 'react'
import Honeybadger from 'honeybadger-js'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      notify // via withRedux
    } = props

    const handleQueryError = error => {
      notify({
        variant: 'error',
        autoHide: false,
        message: 'Something went wrong. Please try again or refresh.'
      })
      Honeybadger.notify(error, 'QueryError')
      console.log('QueryError', error)
    }

    // if the GraphQL data payload indicates that the user is not logged in,
    // redirect to /login and return false for further handling in withQuery
    const handleLoggedInQueryCompleted = data => {
      const { viewer } = data || {}

      if (viewer) {
        return true
      } else {
        window.location.pathname = '/login'
        return false
      }
    }

    const handleAdminQueryCompleted = data => {
      const { adminUser } = data || {}

      if (adminUser) {
        return true
      } else {
        window.location.pathname = '/admin/login'
        return false
      }
    }

    return (
      <WrappedComponent
        onQueryError={handleQueryError}
        onLoggedInQueryCompleted={handleLoggedInQueryCompleted}
        onAdminQueryCompleted={handleAdminQueryCompleted}
        {...props}
      />
    )
  }
}

export default withEventHandlers
